import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FiestaClubComponent } from './fiesta-club.component';
import { RouterModule } from '@angular/router';
import { SuccessComponent } from './success/success.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [
    FiestaClubComponent,
    SuccessComponent
  ],
  providers: [
  ]
})
export class FiestaClubModule { }



// WEBPACK FOOTER //
// ./src/app/fiesta-club/fiesta-club.module.ts